import { Link } from 'react-router-dom'
import SEOHead from '../components/SEOHead'
import GallerySection from '../components/GallerySection'
import YouTubeFacade from '../components/YouTubeFacade'
import ContactForm from '../components/ContactForm'
import { useCmsPage } from '../hooks/useCmsPage'

export default function FirmafestPage() {
  const { page } = useCmsPage('firmafest')

  const title = page?.meta_title || 'DJ til firmafest — Casper DJ'
  const description =
    page?.meta_description ||
    'Søger du en DJ til firmafesten?  CasperDJ, kan tilpasse musik og setup til alle former for arrangementer: små og store virksomheder, hyggelige julefrokoster og uforglemmelige sommerfester!, Søger du en DJ til firmafesten?  CasperDJ, kan tilpasse musik og setup til alle former for arrangementer: små og store virksomheder, hyggelige julefrokoster og uforglemmelige sommerfester!'

  const extractVideoId = (url) => {
    if (!url) return 'cU16yYjhU9E'
    if (url.includes('embed/')) {
      return url.split('embed/')[1]?.split('?')[0]?.split('&')[0] || 'cU16yYjhU9E'
    }
    if (url.includes('v=')) {
      return url.split('v=')[1]?.split('&')[0] || 'cU16yYjhU9E'
    }
    if (url.includes('youtu.be/')) {
      return url.split('youtu.be/')[1]?.split('?')[0]?.split('&')[0] || 'cU16yYjhU9E'
    }
    return url.trim() || 'cU16yYjhU9E'
  }

  const videoId = extractVideoId(page?.video_url)

  return (
    <div className="bg-neutral-950 text-white min-h-screen">
      <SEOHead title={title} description={description} />

      {/* Hero & Video */}
      <section className="pt-32 pb-16 md:pt-48 md:pb-24 border-b border-neutral-900 bg-neutral-900/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-10">
            <div className="space-y-6">
              <span className="text-xs font-semibold tracking-widest text-gold-400 uppercase">
                DJ til din FIRMAFEST
              </span>
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-white leading-tight">
                Dj til din Firmafest - med Casperdj
              </h1>
              <p className="text-base sm:text-lg text-neutral-300 leading-relaxed">
                En god firmafest er en positiv samlende oplevelse, og som dj til firmafesten, så sikrer{' '}
                <Link to="/" className="text-gold-400 font-semibold hover:underline">
                  CasperDJ
                </Link>{' '}
                at festen bliver, som I ønsker den. Vi kan tilpasse musik og setup til alle former for arrangementer: små og store virksomheder, hyggelige julefrokoster og uforglemmelige sommerfest-brag.
              </p>

              <div className="pt-2">
                <h3 className="text-lg font-bold text-white mb-2">Info - DJ til jeres firmafest</h3>
                <p className="text-sm sm:text-base text-neutral-300 leading-relaxed">
                  Vi leverer musik efter ønske under middagen – og herefter garanterer vi en uimodståelig hitparade, der trækker firmafesten ud på dansegulvet. Diskoteket er på plads, inden gæsterne ankommer og pakket sammen igen, når de sidste er på vej hjem.
                </p>
                <p className="text-sm sm:text-base text-neutral-300 leading-relaxed mt-3">
                  Et hvilket som helst setup er muligt, og ønsker I en fest, der virkelig skiller sig ud fra de andre, giver vi gerne inspiration til temafester.
                </p>
                <p className="text-sm sm:text-base text-neutral-300 leading-relaxed mt-3">
                  Mangler du en dj til firmafesten, så{' '}
                  <Link to="/kontakt" className="text-gold-400 font-semibold hover:underline">
                    kontakt
                  </Link>{' '}
                  os endelig for mere information og for et godt tilbud, så I kan få den rette musik til firmafesten.
                </p>
              </div>

              <div className="pt-2 flex flex-wrap gap-4">
                <Link
                  to="/kontakt"
                  className="px-8 py-3.5 bg-gold-400 text-neutral-950 font-bold text-sm uppercase tracking-wider rounded-xl hover:bg-gold-300 transition-colors shadow-lg cursor-pointer"
                >
                  Kontakt mig
                </Link>
                <a
                  href="tel:+4530405006"
                  className="px-6 py-3.5 border border-neutral-800 bg-neutral-900 text-white font-bold text-sm uppercase tracking-wider rounded-xl hover:border-gold-400/50 hover:text-gold-400 transition-colors cursor-pointer flex items-center gap-2 whitespace-nowrap"
                >
                  <i className="fa-solid fa-phone text-gold-400 text-xs" aria-hidden="true" />
                  <span className="whitespace-nowrap">+45 30 40 50 06</span>
                </a>
              </div>
            </div>

            {/* Video facade under text */}
            <div className="pt-4">
              <YouTubeFacade
                videoId={videoId}
                title="CasperDJ til firmafest"
                poster={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
              />
            </div>
          </div>
        </div>
      </section>

      {/* CasperDJ sikrer altid */}
      <section className="py-20 bg-neutral-950 border-b border-neutral-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mx-auto text-center mb-14">
            <span className="text-xs font-semibold tracking-widest text-gold-400 uppercase">
              Højeste kvalitet &amp; service
            </span>
            <h2 className="text-3xl font-extrabold text-white mt-1">
              CasperDJ sikrer altid
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="p-8 rounded-2xl bg-neutral-900/60 border border-neutral-800 space-y-4">
              <div className="w-12 h-12 rounded-xl bg-gold-400/10 border border-gold-400/30 text-gold-400 flex items-center justify-center text-lg">
                <i className="fa-solid fa-shield-check" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-bold text-white">
                Professionel afvikling af jeres fest
              </h3>
              <p className="text-sm text-neutral-300 leading-relaxed">
                Vi koordinerer hver eneste detalje for at sikre, at jeres fest forløber glat og problemfrit. Vi står klar til at håndtere alt fra lyd- og lysopsætning til at styre musikken og underholde jeres gæster. Med fokus på professionalisme og kvalitet garanterer vi, at jeres begivenhed bliver en succesfuld og mindeværdig oplevelse for alle.
              </p>
            </div>

            <div className="p-8 rounded-2xl bg-neutral-900/60 border border-neutral-800 space-y-4">
              <div className="w-12 h-12 rounded-xl bg-gold-400/10 border border-gold-400/30 text-gold-400 flex items-center justify-center text-lg">
                <i className="fa-solid fa-music" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-bold text-white">
                Et varieret musikudvalg, der kan tilpasses forskellige kulturer og generationer
              </h3>
              <p className="text-sm text-neutral-300 leading-relaxed">
                Vi tilbyder et omfattende udvalg af musikgenrer og sange, der kan tilpasses enhver smag og præference. Uanset om I ønsker klassiske hits, de nyeste hits eller internationale favoritter, sørger vi for at skabe den perfekte lydkulisse, der appellerer til både unge og gamle, og som holder dansegulvet fyldt hele aftenen.
              </p>
            </div>

            <div className="p-8 rounded-2xl bg-neutral-900/60 border border-neutral-800 space-y-4">
              <div className="w-12 h-12 rounded-xl bg-gold-400/10 border border-gold-400/30 text-gold-400 flex items-center justify-center text-lg">
                <i className="fa-solid fa-clock" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-bold text-white">
                Opstilling af diskotek inden gæsternes ankomst og hurtig nedpakning efter festen
              </h3>
              <p className="text-sm text-neutral-300 leading-relaxed">
                Vi sørger for at have alt klar til festen, så I kan slappe af og nyde begivenheden uden stress eller bekymringer. Efter festen er slut, pakker vi hurtigt og effektivt alt ned, så I kan sige farvel til jeres gæster med lethed og ro i sindet.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <GallerySection
        gallerySlug="firmafest-billeder"
        title="Billeder fra firmafester"
        subtitle="Se stemningen fra festlige virksomhedsevents med Casper DJ."
      />

      {/* Contact Form Section */}
      <section className="py-20 bg-neutral-950 border-t border-neutral-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <ContactForm
            title="Få et tilbud til firmafesten"
            subtitle="Udfyld formularen eller kontakt mig direkte på +45 30 40 50 06 for en uforpligtende snak."
          />
        </div>
      </section>
    </div>
  )
}
